import { render, staticRenderFns } from "./rb.vue?vue&type=template&id=477c92bb&scoped=true&"
import script from "./rb.vue?vue&type=script&lang=js&"
export * from "./rb.vue?vue&type=script&lang=js&"
import style0 from "./rb.vue?vue&type=style&index=0&lang=less&"
import style1 from "./rb.vue?vue&type=style&index=1&id=477c92bb&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c92bb",
  null
  
)

export default component.exports